import gql from 'graphql-tag';

export default gql`
  query standardizeAddress($input: AddressInput) {
    standardizeAddress(input: $input) {
      addressLine1
      addressLine2
      city
      state
      zipCode
      country
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/queries/standardizeAddress.js